<script lang="ts">
    import { settings } from "@lib/store";
    import Moon from "@icons/Moon.svelte";
    import Sun from "@icons/Sun.svelte";

    const toggleDarkMode = () => {
        settings.update((s) => ({
            ...s,
            dark_mode: !s.dark_mode,
        }));
    };
</script>

<button
    class="icon"
    type="button"
    onclick={toggleDarkMode}
    aria-label={$settings.dark_mode ? "Switch to light mode" : "Switch to dark mode"}
>
    {#if $settings.dark_mode}
        <Sun />
    {:else}
        <Moon />
    {/if}
</button>

